import React, { useEffect, useState } from 'react';
import Overlay from './components/lavalle/Overlay';
import GameReward from './pages/GameReward';
import Passport from './pages/Passport';
import InstructionsVillageInfo from './pages/VillageInfo';
import Instructions from './pages/lavalle/Instructions';
import Amorino from './pages/lavalle/restaurants/Amorino';
import Laduree from './pages/lavalle/restaurants/Laduree';
import MenuPalais from './pages/lavalle/restaurants/MenuPalais';
import PierreHerme from './pages/lavalle/restaurants/PierreHerme';
import PretAManger from './pages/lavalle/restaurants/PretAManger';
import VeroLatte from './pages/lavalle/restaurants/VeroLatte';
import LaValleShoppingExpress from './pages/lavalle/ShoppingExpress';
import LaValleAttractions from './pages/lavalle/Attractions';
import LaValleArtAndCulture from './pages/lavalle/ArtAndCulture';
import LaValleMember from './pages/lavalle/Member';
import LaVallePersonalShopper from './pages/lavalle/PersonalShopper';
import LaVallePersonalStylist from './pages/lavalle/apartment/PersonalStylist';
import LaValleShopFromHome from './pages/lavalle/apartment/ShopFromHome';
import LaValleApartmentWelcome from './pages/lavalle/apartment/Welcome';
import LaValleApartmentServices from './pages/lavalle/apartment/Services';
import LaValleServices from './pages/lavalle/Services';
import { disptchCTAClickObject } from './Analytics';

const villageName = 'la_vallee';

function LaValleApp() {
  const [activeScene, setActiveScene] = useState('room-1');
  const [instructionsActive, setInstructionsActive] = useState(false);
  const [villageInfoActive, setVillageInfoActive] = useState(false);
  const [passportActive, setPassportActive] = useState(false);
  const [gameRewardActive, setGameRewardActive] = useState(false);
  const [amorinoActive, setAmorinoActive] = useState(false);
  const [ladureeActive, setLadureeActive] = useState(false);
  const [menuPalaisActive, setMenuPalaisActive] = useState(false);
  const [pierreActive, setPierreActive] = useState(false);
  const [pretMangerActive, setPretMangerActive] = useState(false);
  const [veroLatteActive, setVeroLatteActive] = useState(false);
  const [shoppingExpressActive, setShoppingExpressActive] = useState(false);
  const [attractionsActive, setAttractionsActive] = useState(false);
  const [artCultureActive, setArtCultureActive] = useState(false);
  const [memberActive, setMemberActive] = useState(false);
  const [personalShopperActive, setPersonalShopperActive] = useState(false);
  const [personalStylistActive, setPersonalStylistActive] = useState(false);
  const [sfhActive, setSfhActive] = useState(false);
  const [apartmentWelcomeActive, setApartmentWelcomeActive] = useState(false);
  const [apartmentServicesActive, setApartmentServicesActive] = useState(false);
  const [servicesActive, setServicesActive] = useState(false);

  const openVillageInfo = () => {
    setVillageInfoActive(true);
  };

  const closeInstructions = () => {
    toggleInstructionsAction(false);
    setVillageInfoActive(true);
  };

  const openPassport = () => {
    setPassportActive(true);
  };

  const updateActiveScene = (sceneName: string) => {
    if (activeScene !== sceneName) {
      setActiveScene(sceneName);
      window.changeUrls();
    }
  };

  const openGameReward = () => {
    disptchCTAClickObject('lavallee', 'Button', 'GameReward', 'Open', '');
    setGameRewardActive(true);
  };

  const closeGameReward = () => {
    disptchCTAClickObject('lavallee', 'Button', 'GameReward', 'Close', '');
    setGameRewardActive(false);
  };

  const openAmorino = () => {
    disptchCTAClickObject('lavallee', 'Button', 'Amorino', 'Open', '');
    setAmorinoActive(true);
  };

  const closeAmorino = () => {
    disptchCTAClickObject('lavallee', 'Button', 'Amorino', 'Close', '');
    setAmorinoActive(false);
  };

  const openLaduree = () => {
    disptchCTAClickObject('lavallee', 'Button', 'Laduree', 'Open', '');
    setLadureeActive(true);
  };

  const closeLaduree = () => {
    disptchCTAClickObject('lavallee', 'Button', 'Laduree', 'Close', '');
    setLadureeActive(false);
  };

  const openMenuPalais = () => {
    disptchCTAClickObject('lavallee', 'Button', 'MenuPalais', 'Open', '');
    setMenuPalaisActive(true);
  };

  const closeMenuPalais = () => {
    disptchCTAClickObject('lavallee', 'Button', 'MenuPalais', 'Close', '');
    setMenuPalaisActive(false);
  };

  const openPierreHerme = () => {
    disptchCTAClickObject('lavallee', 'Button', 'PierreHerme', 'Open', '');
    setPierreActive(true);
  };

  const closePierreHerme = () => {
    disptchCTAClickObject('lavallee', 'Button', 'PierreHerme', 'Close', '');
    setPierreActive(false);
  };

  const openPretManger = () => {
    disptchCTAClickObject('lavallee', 'Button', 'PretManger', 'Open', '');
    setPretMangerActive(true);
  };

  const closePretManger = () => {
    disptchCTAClickObject('lavallee', 'Button', 'PretManger', 'Close', '');
    setPretMangerActive(false);
  };

  const openVeroLattee = () => {
    disptchCTAClickObject('lavallee', 'Button', 'VeroLatte', 'Open', '');
    setVeroLatteActive(true);
  };

  const closeVeroLattee = () => {
    disptchCTAClickObject('lavallee', 'Button', 'VeroLatte', 'Close', '');
    setVeroLatteActive(false);
  };

  const openLaValleShoppingExpress = () => {
    disptchCTAClickObject('lavallee', 'Button', 'ShoppingExpress', 'Open', '');
    setShoppingExpressActive(true);
  };

  const closeLaValleShoppingExpress = () => {
    disptchCTAClickObject('lavallee', 'Button', 'ShoppingExpress', 'Close', '');
    setShoppingExpressActive(false);
  };

  const openLaValleAttractions = () => {
    disptchCTAClickObject('lavallee', 'Button', 'Attractions', 'Open', '');
    setAttractionsActive(true);
  };

  const closeLaValleAttractions = () => {
    disptchCTAClickObject('lavallee', 'Button', 'Attractions', 'Close', '');
    setAttractionsActive(false);
  };

  const openLaValleAc = () => {
    disptchCTAClickObject('lavallee', 'Button', 'ArtCulture', 'Open', '');
    setArtCultureActive(true);
  };

  const closeLaValleAc = () => {
    disptchCTAClickObject('lavallee', 'Button', 'ArtCulture', 'Close', '');
    setArtCultureActive(false);
  };

  const openLaValleMember = () => {
    disptchCTAClickObject('lavallee', 'Button', 'Member', 'Open', '');
    setMemberActive(true);
  };

  const closeLaValleMember = () => {
    disptchCTAClickObject('lavallee', 'Button', 'Member', 'Close', '');
    setMemberActive(false);
  };

  const openLaVallePersonalShopper = () => {
    disptchCTAClickObject('lavallee', 'Button', 'PersonalShopper', 'Open', '');
    setPersonalShopperActive(true);
  };

  const closeLaVallePersonalShopper = () => {
    disptchCTAClickObject('lavallee', 'Button', 'PersonalShopper', 'Close', '');
    setPersonalShopperActive(false);
  };

  const openLaVallePersonalStylist = () => {
    disptchCTAClickObject('lavallee', 'Button', 'PersonalStylist', 'Open', '');
    setPersonalStylistActive(true);
  };

  const closeLaVallePersonalStylist = () => {
    disptchCTAClickObject('lavallee', 'Button', 'PersonalStylist', 'Close', '');
    setPersonalStylistActive(false);
  };

  const openLaValleSfh = () => {
    disptchCTAClickObject('lavallee', 'Button', 'ShopFromHome', 'Open', '');
    setSfhActive(true);
  };

  const closeLaValleSfh = () => {
    disptchCTAClickObject('lavallee', 'Button', 'ShopFromHome', 'Close', '');
    setSfhActive(false);
  };

  const openLaValleApartmentWelcome = () => {
    disptchCTAClickObject('lavallee', 'Button', 'ApartmentWelcome', 'Open', '');
    setApartmentWelcomeActive(true);
  };

  const closeLaValleApartmentWelcome = () => {
    disptchCTAClickObject('lavallee', 'Button', 'ApartmentWelcome', 'Close', '');
    setApartmentWelcomeActive(false);
  };

  const openLaValleApartmentServices = () => {
    disptchCTAClickObject('lavallee', 'Button', 'ApartmentServices', 'Open', '');
    setApartmentServicesActive(true);
  };

  const closeLaValleApartmentServices = () => {
    disptchCTAClickObject('lavallee', 'Button', 'ApartmentServices', 'Close', '');
    setApartmentServicesActive(false);
  };

  const openLaValleServices = () => {
    disptchCTAClickObject('lavallee', 'Button', 'Services', 'Open', '');
    setServicesActive(true);
  };

  const closeLaValleServices = () => {
    disptchCTAClickObject('lavallee', 'Button', 'Services', 'Close', '');
    setServicesActive(false);
  };

  const toggleInstructionsAction = (isActive: boolean) => {
    const cta_action: string = isActive ? 'Open' : 'Close';
    setInstructionsActive(isActive);
    disptchCTAClickObject('lavallee', 'Button', 'Instructions', cta_action, '');
  };

  const togglePassportAction = (isActive: boolean) => {
    const cta_action: string = isActive ? 'Open' : 'Close';
    setPassportActive(isActive);
    disptchCTAClickObject('lavallee', 'Button', 'Passport', cta_action, '');
  };

  const closeVillageInfo = () => {
    setVillageInfoActive(false);
    disptchCTAClickObject('lavallee', 'Button', 'VillageInfo', 'close', '');
  };

  useEffect(() => {
    window.openVillageInfo = openVillageInfo;
    window.openPassport = openPassport;
    window.updateActiveScene = updateActiveScene;
    window.openGameReward = openGameReward;
    window.openAmorino = openAmorino;
    window.openLaduree = openLaduree;
    window.openMenuPalais = openMenuPalais;
    window.openPierreHerme = openPierreHerme;
    window.openPretManger = openPretManger;
    window.openVeroLattee = openVeroLattee;
    window.openLaValleShoppingExpress = openLaValleShoppingExpress;
    window.openLaValleAttractions = openLaValleAttractions;
    window.openLaValleAc = openLaValleAc;
    window.openLaValleMember = openLaValleMember;
    window.openLaVallePersonalShopper = openLaVallePersonalShopper;
    window.openLaVallePersonalStylist = openLaVallePersonalStylist;
    window.openLaValleSfh = openLaValleSfh;
    window.openLaValleApartmentWelcome = openLaValleApartmentWelcome;
    window.openLaValleApartmentServices = openLaValleApartmentServices;
    window.openLaValleServices = openLaValleServices;
  }, []);

  return (
    <>
      {/* <LoadingScreen setLoadUI={() => setLoadUI(true)} /> */}
      {/* {loadUI && ( */}
      <>
        <Overlay
          closeAllUI={() => {
            setInstructionsActive(false);
          }}
          openFirstModal={() => setInstructionsActive(true)}
          activeScene={activeScene}
          setActiveScene={setActiveScene}
          togglePassport={() => {
            togglePassportAction(!passportActive);
          }}
          toggleInstructions={() => {
            toggleInstructionsAction(!instructionsActive);
          }}
          // toggleMap={() => {
          //   setMapActive(!mapActive);
          // }}
        />
        <Instructions active={instructionsActive} setActive={closeInstructions} />
        <InstructionsVillageInfo
          active={villageInfoActive}
          setActive={() => closeVillageInfo()}
          villageName={villageName}
        />
        <Passport active={passportActive} setActive={() => togglePassportAction(false)} villageName={villageName} />
        <GameReward villageName="lavallee" active={gameRewardActive} setActive={() => closeGameReward()} />
        <Amorino active={amorinoActive} setActive={() => closeAmorino()} />
        <Laduree active={ladureeActive} setActive={() => closeLaduree()} />
        <MenuPalais active={menuPalaisActive} setActive={() => closeMenuPalais()} />
        <PierreHerme active={pierreActive} setActive={() => closePierreHerme()} />
        <PretAManger active={pretMangerActive} setActive={() => closePretManger()} />
        <VeroLatte active={veroLatteActive} setActive={() => closeVeroLattee()} />
        <LaValleShoppingExpress active={shoppingExpressActive} setActive={() => closeLaValleShoppingExpress()} />
        <LaValleAttractions active={attractionsActive} setActive={() => closeLaValleAttractions()} />
        <LaValleArtAndCulture active={artCultureActive} setActive={() => closeLaValleAc()} />
        <LaValleMember active={memberActive} setActive={() => closeLaValleMember()} />
        <LaVallePersonalShopper active={personalShopperActive} setActive={() => closeLaVallePersonalShopper()} />
        <LaVallePersonalStylist active={personalStylistActive} setActive={() => closeLaVallePersonalStylist()} />
        <LaValleShopFromHome active={sfhActive} setActive={() => closeLaValleSfh()} />
        <LaValleApartmentWelcome active={apartmentWelcomeActive} setActive={() => closeLaValleApartmentWelcome()} />
        <LaValleApartmentServices active={apartmentServicesActive} setActive={() => closeLaValleApartmentServices()} />
        <LaValleServices active={servicesActive} setActive={() => closeLaValleServices()} />
      </>
    </>
  );
}

export default LaValleApp;
